import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { AppBar, Grid, Paper, Toolbar, Typography } from '@mui/material';
import queryString from 'query-string';

import { AdminUserSearchResult, UserState } from 'us-web-services';
import useUser from '../../store/useUser';
import UserSearch from './UserSearch';
import ReviewLookup from './ReviewLookup';
import LookupTabs from './LookupTabs';
import PageStyles from '../../styles/PageStyles';

function UserReviews(props: RouteComponentProps) {
  const { classes } = PageStyles();
  const { history, location } = props;
  const userCache = useUser()[0];
  const searchParams = queryString.parse(location.search);
  const [userState, setUserState] = useState<UserState>({
    user: {},
    profile: {},
  });

  useEffect(() => {
    setUserState(userCache);
  }, [userCache, userCache.user.id, userCache.profile.id, searchParams.id]);

  const handleSearch = (term: string) => {
    history.push({ pathname: '/users/lookup', search: `?search=${encodeURIComponent(term)}` });
  };

  const handleSelectUser = (result: AdminUserSearchResult) => {
    if (result.id) {
      history.push({ pathname: '/users/reviews', search: `?id=${result.id}` });
    }
  };

  return (
    <Paper className={classes.paper}>
      <AppBar position='static' color='transparent' elevation={0}>
        <Toolbar>
          <Grid container spacing={2} alignItems='center'>
            <Grid item xs>
              <UserSearch
                onSearch={handleSearch}
                onSelectUser={handleSelectUser}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <div style={{ margin: '40px 16px' }}>
        {userState.user.id && userState.profile.id ? (
          <>
            <LookupTabs user={userState.user} />
            <ReviewLookup />
          </>
        ) : (
          <Typography
            color='textPrimary'
            align='center'
            component='h5'
            variant='h5'
          >
            No user found
          </Typography>
        )}
      </div>
    </Paper>
  );
}

export default withRouter(UserReviews);
